import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import { auth } from "@/firebase";
import Ads from 'vue-google-adsense'
// import OneSignal from "onesignal-vue";


Vue.use(require('vue-script2'))

// Vue.use(OneSignal);

// Vue.use(Ads.Adsense)
// Vue.use(Ads.InArticleAdsense)
// Vue.use(Ads.InFeedAdsense)
// Vue.use(Ads.AutoAdsense, { adClient: 'ca-pub-3802200732953296', isNewAdsCode: true })

Vue.config.productionTip = false;

Vue.prototype.$hostname = Vue.config.productionTip
  ? "https://www.your-api.com"
  : "http://192.168.1.133:8080/api";

let app = "";

auth.onAuthStateChanged(function(user) {
  if (user) {
    // User is signed in.
    console.log("auth.onAuthStateChanged user");
    console.log(auth.currentUser);
    store.dispatch("setUsuario", user);
    router.replace("/home");
    // console.log(displayName)
    // ...
  }
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
    // beforeMount() {
    //   this.$OneSignal.init({
    //     appId: "8ac2f9d2-e4e2-4d69-b107-e1565834338a",
    //     safari_web_id: "",
    //     allowLocalhostAsSecureOrigin: true,
    //     notifyButton: {
    //       enable: false,
    //     },
    //   });
    // },
  }).$mount("#app");
});
